/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Action } from './Action';
import {
    ActionFromJSON,
    ActionFromJSONTyped,
    ActionToJSON,
} from './Action';

/**
 * 
 * @export
 * @interface AddInteractionActionRequest
 */
export interface AddInteractionActionRequest {
    /**
     * 
     * @type {Action}
     * @memberof AddInteractionActionRequest
     */
    action: Action;
    /**
     * 
     * @type {string}
     * @memberof AddInteractionActionRequest
     */
    interactionId: string;
}

/**
 * Check if a given object implements the AddInteractionActionRequest interface.
 */
export function instanceOfAddInteractionActionRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "action" in value;
    isInstance = isInstance && "interactionId" in value;

    return isInstance;
}

export function AddInteractionActionRequestFromJSON(json: any): AddInteractionActionRequest {
    return AddInteractionActionRequestFromJSONTyped(json, false);
}

export function AddInteractionActionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddInteractionActionRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'action': ActionFromJSON(json['action']),
        'interactionId': json['interactionId'],
    };
}

export function AddInteractionActionRequestToJSON(value?: AddInteractionActionRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'action': ActionToJSON(value.action),
        'interactionId': value.interactionId,
    };
}

